import React from 'react';
import { toast } from 'sonner';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  
  componentDidCatch(error, errorInfo) {
    console.error('React ErrorBoundary caught:', error, errorInfo);
  }
  
  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };
  
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center px-6">
          <div className="max-w-md w-full text-center">
            <div className="w-16 h-16 bg-[#B58A3F]/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <span className="text-4xl">☕</span>
            </div>
            <h1 className="heading-serif text-3xl text-[#142A1D] mb-4 font-light">
              Algo salió mal
            </h1>
            <p className="text-[#142A1D] opacity-70 mb-8">
              Ocurrió un error inesperado. Por favor recarga la página o vuelve al inicio.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="btn-primary"
              >
                Recargar
              </button>
              <button
                onClick={this.handleReset}
                className="px-6 py-3 border-2 border-[#E5DEC5] text-[#142A1D] rounded-lg hover:bg-[#F2EBE1] transition-colors"
              >
                Ir al Inicio
              </button>
            </div>
          </div>
        </div>
      );
    }
    
    return this.props.children;
  }
}

// Install global error handlers for uncaught errors and promises
export const installGlobalErrorHandlers = () => {
  // Handle uncaught promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);
    // Prevent "Script error" from breaking the app
    // Only show toast for meaningful errors
    const msg = event.reason?.message || event.reason?.toString?.() || '';
    if (msg && !msg.includes('Script error') && !msg.includes('ResizeObserver')) {
      try {
        toast.error('Ocurrió un error. Por favor intenta de nuevo.');
      } catch (e) {
        // toast might not be available yet
      }
    }
    event.preventDefault();
  });
  
  // Handle uncaught errors
  window.addEventListener('error', (event) => {
    // Ignore ResizeObserver errors (browser noise)
    if (event.message?.includes('ResizeObserver')) {
      event.preventDefault();
      return;
    }
    
    // Ignore cross-origin "Script error" (from Wompi iframe, third-party scripts)
    if (event.message === 'Script error.' || event.message === 'Script error') {
      event.preventDefault();
      return;
    }
    
    console.error('Uncaught error:', event.error || event.message);
  });
};

export default ErrorBoundary;
